import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import { isBrowser } from 'utils/deploymentInfo';
import cache from 'utils/cache';
import dispatchWorkRequest from 'utils/work/dispatchWorkRequest';
import downloadFromS3 from 'utils/work/downloadFromS3';
import waitForWorkRequest from 'utils/work/waitForWorkRequest';

// retrieveData will try to get the data for the given experimentId and ETag from
// the fastest source possible. It will try to get the data in order from:
// 1. Browser cache
// 2. S3 (cache) via signedURL
// 3. Worker
//   3.1. Via socket (small data)
//   3.2. Via S3 (large data) via signedURL
var retrieveData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(experimentId, ETag, signedUrl, request, timeout, body, dispatch, useCache) {
    var cachedData, _yield$waitForWorkReq, workerSignedUrl, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!useCache) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return cache.get(ETag);
          case 3:
            _context.t0 = _context.sent;
            _context.next = 7;
            break;
          case 6:
            _context.t0 = null;
          case 7:
            cachedData = _context.t0;
            if (!cachedData) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", cachedData);
          case 10:
            if (!signedUrl) {
              _context.next = 14;
              break;
            }
            _context.next = 13;
            return downloadFromS3(body.name, signedUrl);
          case 13:
            return _context.abrupt("return", _context.sent);
          case 14:
            _context.next = 16;
            return waitForWorkRequest(ETag, experimentId, request, timeout, dispatch);
          case 16:
            _yield$waitForWorkReq = _context.sent;
            workerSignedUrl = _yield$waitForWorkReq.signedUrl;
            data = _yield$waitForWorkReq.data;
            if (!data) {
              _context.next = 21;
              break;
            }
            return _context.abrupt("return", data);
          case 21:
            _context.next = 23;
            return downloadFromS3(body.name, workerSignedUrl);
          case 23:
            return _context.abrupt("return", _context.sent);
          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function retrieveData(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref.apply(this, arguments);
  };
}();
var fetchWork = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(experimentId, body, getState, dispatch) {
    var optionals,
      _optionals$extras,
      extras,
      _optionals$timeout,
      timeout,
      _optionals$broadcast,
      broadcast,
      _optionals$onETagGene,
      onETagGenerated,
      _yield$dispatchWorkRe,
      ETag,
      signedUrl,
      request,
      useCache,
      data,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            optionals = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : {};
            _optionals$extras = optionals.extras, extras = _optionals$extras === void 0 ? undefined : _optionals$extras, _optionals$timeout = optionals.timeout, timeout = _optionals$timeout === void 0 ? 180 : _optionals$timeout, _optionals$broadcast = optionals.broadcast, broadcast = _optionals$broadcast === void 0 ? false : _optionals$broadcast, _optionals$onETagGene = optionals.onETagGenerated, onETagGenerated = _optionals$onETagGene === void 0 ? function () {} : _optionals$onETagGene;
            if (isBrowser) {
              _context2.next = 4;
              break;
            }
            throw new Error('Disabling network interaction on server');
          case 4:
            _context2.next = 6;
            return dispatchWorkRequest(experimentId, body, timeout, _objectSpread({
              broadcast: broadcast
            }, extras), getState);
          case 6:
            _yield$dispatchWorkRe = _context2.sent;
            ETag = _yield$dispatchWorkRe.ETag;
            signedUrl = _yield$dispatchWorkRe.signedUrl;
            request = _yield$dispatchWorkRe.request;
            onETagGenerated(ETag);
            useCache = body.name !== 'GeneExpression'; // 2. Try to get the data from the fastest source possible
            _context2.next = 14;
            return retrieveData(experimentId, ETag, signedUrl, request, timeout, body, dispatch, useCache);
          case 14:
            data = _context2.sent;
            if (!useCache) {
              _context2.next = 18;
              break;
            }
            _context2.next = 18;
            return cache.set(ETag, data);
          case 18:
            return _context2.abrupt("return", data);
          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function fetchWork(_x9, _x10, _x11, _x12) {
    return _ref2.apply(this, arguments);
  };
}();
export default fetchWork;